// @flow

import type { Action } from './store.type';

type KlaviyosSuccess = {
  data: any
};

type KlaviyoFailure = {
  error: any
};

/* #region: Get klaviyo status */
export const GET_KLAVIYO_STATUS_REQUEST = 'GET_KLAVIYO_STATUS_REQUEST';
type GET_KLAVIYO_STATUS_REQUEST_TYPE = 'GET_KLAVIYO_STATUS_REQUEST';

export const GET_KLAVIYO_STATUS_SUCCESS = 'GET_KLAVIYO_STATUS_SUCCESS';
type GET_KLAVIYO_STATUS_SUCCESS_TYPE = 'GET_KLAVIYO_STATUS_SUCCESS';

export const GET_KLAVIYO_STATUS_FAILURE = 'GET_KLAVIYO_STATUS_FAILURE';
type GET_KLAVIYO_STATUS_FAILURE_TYPE = 'GET_KLAVIYO_STATUS_FAILURE';

type GetKlaviyoStatusRequestAction = Action<GET_KLAVIYO_STATUS_REQUEST_TYPE, null>;

type GetKlaviyoStatusSuccessAction = Action<GET_KLAVIYO_STATUS_SUCCESS_TYPE, KlaviyosSuccess>;

type GetKlaviyoStatusFailureAction = Action<GET_KLAVIYO_STATUS_FAILURE_TYPE, KlaviyoFailure>;
/* #endregion */

/* #region: Check klaviyo install status  */
export const CHECK_KLAVIYO_INSTALL_STATUS_REQUEST = 'CHECK_KLAVIYO_INSTALL_STATUS_REQUEST';
type CHECK_KLAVIYO_INSTALL_STATUS_REQUEST_TYPE = 'CHECK_KLAVIYO_INSTALL_STATUS_REQUEST';

export const CHECK_KLAVIYO_INSTALL_STATUS_SUCCESS = 'CHECK_KLAVIYO_INSTALL_STATUS_SUCCESS';
type CHECK_KLAVIYO_INSTALL_STATUS_SUCCESS_TYPE = 'CHECK_KLAVIYO_INSTALL_STATUS_SUCCESS';

export const CHECK_KLAVIYO_INSTALL_STATUS_FAILURE = 'CHECK_KLAVIYO_INSTALL_STATUS_FAILURE';
type CHECK_KLAVIYO_INSTALL_STATUS_FAILURE_TYPE = 'CHECK_KLAVIYO_INSTALL_STATUS_FAILURE';

type CheckKlaviyoInstallStatusAction = Action<CHECK_KLAVIYO_INSTALL_STATUS_REQUEST_TYPE, null>;

type CheckKlaviyoInstallStatusSuccessAction = Action<
  CHECK_KLAVIYO_INSTALL_STATUS_SUCCESS_TYPE,
  KlaviyosSuccess
>;

type CheckKlaviyoInstallStatusFailureAction = Action<
  CHECK_KLAVIYO_INSTALL_STATUS_FAILURE_TYPE,
  KlaviyoFailure
>;
/* #endregion */

/* #region: Generate klaviyo link  */
export const GENERATE_KLAVIYO_LINK_REQUEST = 'GENERATE_KLAVIYO_LINK_REQUEST';
type GENERATE_KLAVIYO_LINK_REQUEST_TYPE = 'GENERATE_KLAVIYO_LINK_REQUEST';

export const GENERATE_KLAVIYO_LINK_SUCCESS = 'GENERATE_KLAVIYO_LINK_SUCCESS';
type GENERATE_KLAVIYO_LINK_SUCCESS_TYPE = 'GENERATE_KLAVIYO_LINK_SUCCESS';

export const GENERATE_KLAVIYO_LINK_FAILURE = 'GENERATE_KLAVIYO_LINK_FAILURE';
type GENERATE_KLAVIYO_LINK_FAILURE_TYPE = 'GENERATE_KLAVIYO_LINK_FAILURE';

type GenerateKlaviyoLinkAction = Action<GENERATE_KLAVIYO_LINK_REQUEST_TYPE, null>;

type GenerateKlaviyoLinkSuccessAction = Action<GENERATE_KLAVIYO_LINK_SUCCESS_TYPE, KlaviyosSuccess>;

type GenerateKlaviyoLinkFailureAction = Action<GENERATE_KLAVIYO_LINK_FAILURE_TYPE, KlaviyoFailure>;
/* #endregion */

/* #region: Oauth klaviyo callback  */
export const OAUTH_KLAVIYO_REQUEST = 'OAUTH_KLAVIYO_REQUEST';
type OAUTH_KLAVIYO_REQUEST_TYPE = 'OAUTH_KLAVIYO_REQUEST';

export const OAUTH_KLAVIYO_SUCCESS = 'OAUTH_KLAVIYO_SUCCESS';
type OAUTH_KLAVIYO_SUCCESS_TYPE = 'OAUTH_KLAVIYO_SUCCESS';

export const OAUTH_KLAVIYO_FAILURE = 'OAUTH_KLAVIYO_FAILURE';
type OAUTH_KLAVIYO_FAILURE_TYPE = 'OAUTH_KLAVIYO_FAILURE';

type OauthKlaviyoAction = Action<OAUTH_KLAVIYO_REQUEST_TYPE, null>;

type OauthKlaviyoSuccessAction = Action<OAUTH_KLAVIYO_SUCCESS_TYPE, KlaviyosSuccess>;

type OauthKlaviyoFailureAction = Action<OAUTH_KLAVIYO_FAILURE_TYPE, KlaviyoFailure>;
/* #endregion */

/* #region: Toggle klaviyo  */
export const TOGGLE_KLAVIYO_REQUEST = 'TOGGLE_KLAVIYO_REQUEST';
type TOGGLE_KLAVIYO_REQUEST_TYPE = 'TOGGLE_KLAVIYO_REQUEST';

export const TOGGLE_KLAVIYO_SUCCESS = 'TOGGLE_KLAVIYO_SUCCESS';
type TOGGLE_KLAVIYO_SUCCESS_TYPE = 'TOGGLE_KLAVIYO_SUCCESS';

export const TOGGLE_KLAVIYO_FAILURE = 'TOGGLE_KLAVIYO_FAILURE';
type TOGGLE_KLAVIYO_FAILURE_TYPE = 'TOGGLE_KLAVIYO_FAILURE';

type ToggleKlaviyoAction = Action<TOGGLE_KLAVIYO_REQUEST_TYPE, null>;

type ToggleKlaviyoSuccessAction = Action<TOGGLE_KLAVIYO_SUCCESS_TYPE, KlaviyosSuccess>;

type ToggleKlaviyoFailureAction = Action<TOGGLE_KLAVIYO_FAILURE_TYPE, KlaviyoFailure>;
/* #endregion */

/* #region: Preview klaviyo recommendation (rule-filtered product match preview) */
export const PREVIEW_KLAVIYO_RECOMMENDATION_REQUEST = 'PREVIEW_KLAVIYO_RECOMMENDATION_REQUEST';
type PREVIEW_KLAVIYO_RECOMMENDATION_REQUEST_TYPE = 'PREVIEW_KLAVIYO_RECOMMENDATION_REQUEST';

export const PREVIEW_KLAVIYO_RECOMMENDATION_SUCCESS = 'PREVIEW_KLAVIYO_RECOMMENDATION_SUCCESS';
type PREVIEW_KLAVIYO_RECOMMENDATION_SUCCESS_TYPE = 'PREVIEW_KLAVIYO_RECOMMENDATION_SUCCESS';

export const PREVIEW_KLAVIYO_RECOMMENDATION_FAILURE = 'PREVIEW_KLAVIYO_RECOMMENDATION_FAILURE';
type PREVIEW_KLAVIYO_RECOMMENDATION_FAILURE_TYPE = 'PREVIEW_KLAVIYO_RECOMMENDATION_FAILURE';

type PreviewKlaviyoRecommendationAction = Action<PREVIEW_KLAVIYO_RECOMMENDATION_REQUEST_TYPE, null>;

type PreviewKlaviyoRecommendationSuccessAction = Action<
  PREVIEW_KLAVIYO_RECOMMENDATION_SUCCESS_TYPE,
  KlaviyosSuccess
>;

type PreviewKlaviyoRecommendationFailureAction = Action<
  PREVIEW_KLAVIYO_RECOMMENDATION_FAILURE_TYPE,
  KlaviyoFailure
>;
/* #endregion */

/* #region: Update klaviyo banner  */
export const UPDATE_KLAVIYO_BANNER_REQUEST = 'UPDATE_KLAVIYO_BANNER_REQUEST';
type UPDATE_KLAVIYO_BANNER_REQUEST_TYPE = 'UPDATE_KLAVIYO_BANNER_REQUEST';

export const UPDATE_KLAVIYO_BANNER_SUCCESS = 'UPDATE_KLAVIYO_BANNER_SUCCESS';
type UPDATE_KLAVIYO_BANNER_SUCCESS_TYPE = 'UPDATE_KLAVIYO_BANNER_SUCCESS';

export const UPDATE_KLAVIYO_BANNER_FAILURE = 'UPDATE_KLAVIYO_BANNER_FAILURE';
type UPDATE_KLAVIYO_BANNER_FAILURE_TYPE = 'UPDATE_KLAVIYO_BANNER_FAILURE';

type UpdateKlaviyoBannerAction = Action<UPDATE_KLAVIYO_BANNER_REQUEST_TYPE, null>;

type UpdateKlaviyoBannerSuccessAction = Action<UPDATE_KLAVIYO_BANNER_SUCCESS_TYPE, KlaviyosSuccess>;

type UpdateKlaviyoBannerFailureAction = Action<UPDATE_KLAVIYO_BANNER_FAILURE_TYPE, KlaviyoFailure>;
/* #endregion */

/* #region: List klaviyo recommendations */
export const GET_KLAVIYO_RECOMMENDATIONS_REQUEST = 'GET_KLAVIYO_RECOMMENDATIONS_REQUEST';
type GET_KLAVIYO_RECOMMENDATIONS_REQUEST_TYPE = 'GET_KLAVIYO_RECOMMENDATIONS_REQUEST';

export const GET_KLAVIYO_RECOMMENDATIONS_SUCCESS = 'GET_KLAVIYO_RECOMMENDATIONS_SUCCESS';
type GET_KLAVIYO_RECOMMENDATIONS_SUCCESS_TYPE = 'GET_KLAVIYO_RECOMMENDATIONS_SUCCESS';

export const GET_KLAVIYO_RECOMMENDATIONS_FAILURE = 'GET_KLAVIYO_RECOMMENDATIONS_FAILURE';
type GET_KLAVIYO_RECOMMENDATIONS_FAILURE_TYPE = 'GET_KLAVIYO_RECOMMENDATIONS_FAILURE';

type GetKlaviyoRecommendationsAction = Action<GET_KLAVIYO_RECOMMENDATIONS_REQUEST_TYPE, null>;

type GetKlaviyoRecommendationsSuccessAction = Action<
  GET_KLAVIYO_RECOMMENDATIONS_SUCCESS_TYPE,
  KlaviyosSuccess
>;

type GetKlaviyoRecommendationsFailureAction = Action<
  GET_KLAVIYO_RECOMMENDATIONS_FAILURE_TYPE,
  KlaviyoFailure
>;
/* #endregion */

/* #region: Get one klaviyo recommendation */
export const GET_KLAVIYO_RECOMMENDATION_REQUEST = 'GET_KLAVIYO_RECOMMENDATION_REQUEST';
type GET_KLAVIYO_RECOMMENDATION_REQUEST_TYPE = 'GET_KLAVIYO_RECOMMENDATION_REQUEST';

export const GET_KLAVIYO_RECOMMENDATION_SUCCESS = 'GET_KLAVIYO_RECOMMENDATION_SUCCESS';
type GET_KLAVIYO_RECOMMENDATION_SUCCESS_TYPE = 'GET_KLAVIYO_RECOMMENDATION_SUCCESS';

export const GET_KLAVIYO_RECOMMENDATION_FAILURE = 'GET_KLAVIYO_RECOMMENDATION_FAILURE';
type GET_KLAVIYO_RECOMMENDATION_FAILURE_TYPE = 'GET_KLAVIYO_RECOMMENDATION_FAILURE';

type GetKlaviyoRecommendationAction = Action<GET_KLAVIYO_RECOMMENDATION_REQUEST_TYPE, null>;

type GetKlaviyoRecommendationSuccessAction = Action<
  GET_KLAVIYO_RECOMMENDATION_SUCCESS_TYPE,
  KlaviyosSuccess
>;

type GetKlaviyoRecommendationFailureAction = Action<
  GET_KLAVIYO_RECOMMENDATION_FAILURE_TYPE,
  KlaviyoFailure
>;
/* #endregion */

/* #region: Create klaviyo recommendation */
export const CREATE_KLAVIYO_RECOMMENDATION_REQUEST = 'CREATE_KLAVIYO_RECOMMENDATION_REQUEST';
type CREATE_KLAVIYO_RECOMMENDATION_REQUEST_TYPE = 'CREATE_KLAVIYO_RECOMMENDATION_REQUEST';

export const CREATE_KLAVIYO_RECOMMENDATION_SUCCESS = 'CREATE_KLAVIYO_RECOMMENDATION_SUCCESS';
type CREATE_KLAVIYO_RECOMMENDATION_SUCCESS_TYPE = 'CREATE_KLAVIYO_RECOMMENDATION_SUCCESS';

export const CREATE_KLAVIYO_RECOMMENDATION_FAILURE = 'CREATE_KLAVIYO_RECOMMENDATION_FAILURE';
type CREATE_KLAVIYO_RECOMMENDATION_FAILURE_TYPE = 'CREATE_KLAVIYO_RECOMMENDATION_FAILURE';

type CreateKlaviyoRecommendationAction = Action<CREATE_KLAVIYO_RECOMMENDATION_REQUEST_TYPE, null>;

type CreateKlaviyoRecommendationSuccessAction = Action<
  CREATE_KLAVIYO_RECOMMENDATION_SUCCESS_TYPE,
  KlaviyosSuccess
>;

type CreateKlaviyoRecommendationFailureAction = Action<
  CREATE_KLAVIYO_RECOMMENDATION_FAILURE_TYPE,
  KlaviyoFailure
>;
/* #endregion */

/* #region: Update klaviyo recommendation */
export const UPDATE_KLAVIYO_RECOMMENDATION_REQUEST = 'UPDATE_KLAVIYO_RECOMMENDATION_REQUEST';
type UPDATE_KLAVIYO_RECOMMENDATION_REQUEST_TYPE = 'UPDATE_KLAVIYO_RECOMMENDATION_REQUEST';

export const UPDATE_KLAVIYO_RECOMMENDATION_SUCCESS = 'UPDATE_KLAVIYO_RECOMMENDATION_SUCCESS';
type UPDATE_KLAVIYO_RECOMMENDATION_SUCCESS_TYPE = 'UPDATE_KLAVIYO_RECOMMENDATION_SUCCESS';

export const UPDATE_KLAVIYO_RECOMMENDATION_FAILURE = 'UPDATE_KLAVIYO_RECOMMENDATION_FAILURE';
type UPDATE_KLAVIYO_RECOMMENDATION_FAILURE_TYPE = 'UPDATE_KLAVIYO_RECOMMENDATION_FAILURE';

type UpdateKlaviyoRecommendationAction = Action<UPDATE_KLAVIYO_RECOMMENDATION_REQUEST_TYPE, null>;

type UpdateKlaviyoRecommendationSuccessAction = Action<
  UPDATE_KLAVIYO_RECOMMENDATION_SUCCESS_TYPE,
  KlaviyosSuccess
>;

type UpdateKlaviyoRecommendationFailureAction = Action<
  UPDATE_KLAVIYO_RECOMMENDATION_FAILURE_TYPE,
  KlaviyoFailure
>;
/* #endregion */

/* #region: Delete klaviyo recommendation */
export const DELETE_KLAVIYO_RECOMMENDATION_REQUEST = 'DELETE_KLAVIYO_RECOMMENDATION_REQUEST';
type DELETE_KLAVIYO_RECOMMENDATION_REQUEST_TYPE = 'DELETE_KLAVIYO_RECOMMENDATION_REQUEST';

export const DELETE_KLAVIYO_RECOMMENDATION_SUCCESS = 'DELETE_KLAVIYO_RECOMMENDATION_SUCCESS';
type DELETE_KLAVIYO_RECOMMENDATION_SUCCESS_TYPE = 'DELETE_KLAVIYO_RECOMMENDATION_SUCCESS';

export const DELETE_KLAVIYO_RECOMMENDATION_FAILURE = 'DELETE_KLAVIYO_RECOMMENDATION_FAILURE';
type DELETE_KLAVIYO_RECOMMENDATION_FAILURE_TYPE = 'DELETE_KLAVIYO_RECOMMENDATION_FAILURE';

type DeleteKlaviyoRecommendationAction = Action<DELETE_KLAVIYO_RECOMMENDATION_REQUEST_TYPE, any>;

type DeleteKlaviyoRecommendationSuccessAction = Action<
  DELETE_KLAVIYO_RECOMMENDATION_SUCCESS_TYPE,
  KlaviyosSuccess
>;

type DeleteKlaviyoRecommendationFailureAction = Action<
  DELETE_KLAVIYO_RECOMMENDATION_FAILURE_TYPE,
  KlaviyoFailure
>;
/* #endregion */

export const KLAVIYO_STATUS = {
  VERIFYING: 'verifying',
  ACTIVE: 'active',
  REMOVED: 'removed',
  INACTIVE: 'inactive'
};

// Action and State
export type KlaviyoAction =
  | GetKlaviyoStatusRequestAction
  | GetKlaviyoStatusSuccessAction
  | GetKlaviyoStatusFailureAction
  | CheckKlaviyoInstallStatusAction
  | CheckKlaviyoInstallStatusSuccessAction
  | CheckKlaviyoInstallStatusFailureAction
  | GenerateKlaviyoLinkAction
  | GenerateKlaviyoLinkSuccessAction
  | GenerateKlaviyoLinkFailureAction
  | OauthKlaviyoAction
  | OauthKlaviyoSuccessAction
  | OauthKlaviyoFailureAction
  | ToggleKlaviyoAction
  | ToggleKlaviyoSuccessAction
  | ToggleKlaviyoFailureAction
  | UpdateKlaviyoBannerAction
  | UpdateKlaviyoBannerSuccessAction
  | UpdateKlaviyoBannerFailureAction
  | PreviewKlaviyoRecommendationAction
  | PreviewKlaviyoRecommendationSuccessAction
  | PreviewKlaviyoRecommendationFailureAction
  | GetKlaviyoRecommendationsAction
  | GetKlaviyoRecommendationsSuccessAction
  | GetKlaviyoRecommendationsFailureAction
  | GetKlaviyoRecommendationAction
  | GetKlaviyoRecommendationSuccessAction
  | GetKlaviyoRecommendationFailureAction
  | CreateKlaviyoRecommendationAction
  | CreateKlaviyoRecommendationSuccessAction
  | CreateKlaviyoRecommendationFailureAction
  | UpdateKlaviyoRecommendationAction
  | UpdateKlaviyoRecommendationSuccessAction
  | UpdateKlaviyoRecommendationFailureAction
  | DeleteKlaviyoRecommendationAction
  | DeleteKlaviyoRecommendationSuccessAction
  | DeleteKlaviyoRecommendationFailureAction;
